import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PDFPositionTool from "../components/PDFPositionTool";
import "../styles/Devis.css";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PdfToolPageDevis: React.FC = () => {
  const pdfOptions = {
    "Devis REC TTB": {
      url: "../pdfs/ttbRegistration1.pdf", // Chemin du PDF TTB Registration pour Devis.tsx
      fields: { // Structure des champs pour Mon Devis TTB
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"]
      },
      firestoreDoc: "mondevispositions" // Collection Firestore spécifique pour Devis.tsx
    },
    "Devis REC FDA Enregistrement + Gestion": {
      url: "../pdfs/fdaRegistration&Management.pdf", // Chemin du PDF FDA Registration & Management
      fields: { // Structure des champs pour le PDF FDA
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"]
      },
      firestoreDoc: "fdaPositions" // Document Firestore pour les coordonnées FDA
    },
    "Devis REC FDA Gestion": {
      url: "../pdfs/fdaManagement.pdf", // Chemin du PDF FDA Management
      fields: { // Structure des champs pour le PDF FDA Management
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"]
      },
      firestoreDoc: "fdaManagementPositions" // Document Firestore pour les coordonnées FDA Management
    },
    "Devis REC Conseil réglementaire": {
      url: "../pdfs/ContratCadre.pdf", // Chemin du PDF ContratCadre pour Conseil réglementaire
      fields: { // Structure des champs pour le PDF ContratCadre
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"]
      },
      firestoreDoc: "contratCadrePositions" // Document Firestore pour les coordonnées ContratCadre
    },
    "Devis REC CIFER China Registration": {
      url: "../pdfs/ciferChinaRegistration.pdf",
      fields: {
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"]
      },
      firestoreDoc: "ciferChinaRegistrationPositions"
    },
    "REC_hillebrandfdaregistration.pdf": {
      url: "/pdfs/REC_hillebrandfdaregistration.pdf", // Chemin du PDF Hillebrand FDA pour Devis REC
      fields: { // Structure des champs pour le PDF Hillebrand FDA REC
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"],
        hillebrand: ["companyName", "address", "postalCode", "city", "country", "registrationNumber"]
      },
      firestoreDoc: "fdaPositionsREC" // Document Firestore pour les coordonnées Hillebrand FDA REC
    },
    "F_hillebrandfdaregistration.pdf": {
      url: "/pdfs/F_hillebrandfdaregistration.pdf", // Chemin du PDF Hillebrand FDA pour Devis Foodinnov
      fields: { // Structure des champs pour le PDF Hillebrand FDA Foodinnov
        devis: ["id", "companyId", "contact", "opportunityType", "amount", "amount2", "date", "updatedAt", "client", "referenceDevis", "opportunityId", "ttc"],
        opportunities: ["type", "amount", "companyId", "contact", "createdAt", "date", "pu", "qte", "ttc"],
        society: ["name", "siret", "address", "city", "postalCode", "country"],
        hillebrand: ["companyName", "address", "postalCode", "city", "country", "registrationNumber"]
      },
      firestoreDoc: "fdaPositionsFoodinnov" // Document Firestore pour les coordonnées Hillebrand FDA Foodinnov
    }
  };

  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  return (
    <div className="devis-container">
      <ToastContainer position="top-right" autoClose={4000} />
      <Header 
        isAuthenticated={true} 
        onLoginClick={() => navigate('/login')} 
        onHomeClick={() => navigate('/')} 
        onLogoutClick={handleLogout}
      />

      <div style={{ 
        display: "flex", 
        gap: "40px", 
        alignItems: "flex-start", 
        flexWrap: "wrap",
        padding: "20px",
        maxWidth: "1400px",
        margin: "0 auto",
        boxShadow: "none"
      }}>
        <div style={{ 
          flex: 2,
          minWidth: "800px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "20px"
        }}>
          <PDFPositionTool pdfOptions={pdfOptions} />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PdfToolPageDevis;
